import {Element3D} from '../segment-parser/element';
import {PerspectiveCamera} from '../media-engine/camera';

type CameraInfo = {
    position: {
        x: number,
        y: number,
        z: number,
    },
    target: {
        x: number,
        y: number,
        z: number,
    },
}

type Box = {
    min: {
        x: number,
        y: number,
        z: number,
    },
    max: {
        x: number,
        y: number,
        z: number,
    },
}

function serializeCamera(camera: PerspectiveCamera): CameraInfo {
    return {
        position: {
            x: camera.position.x,
            y: camera.position.y,
            z: camera.position.z,
        },
        target: {
            x: camera.target.x,
            y: camera.target.y,
            z: camera.target.z,
        },
    }
}

function serializeBox(box: Box): Box {
    return {
        min: {
            x: box.min.x,
            y: box.min.y,
            z: box.min.z,
        },
        max: {
            x: box.max.x,
            y: box.max.y,
            z: box.max.z,
        },
    }
}

export type Request = Start | Ask | Hover | Move;
export type Strategy = "Greedy" | "Bookmark";

export class Start {
    type: "Start";
    url: string;
    box: Box;
    strategy: Strategy;

    constructor(url: string, box: Box, strategy: Strategy) {
        this.type = "Start";
        this.url = url;
        this.box = serializeBox(box);
        this.strategy = strategy;
    }
}

export class Ask {
    type: "Ask";
    camera: CameraInfo;

    constructor(camera: PerspectiveCamera) {
        this.type = "Ask";
        this.camera = serializeCamera(camera);
    }
}

export class Hover {
    type: "Hover";
    name?: string;

    constructor(name?: string) {
        this.type = "Hover";
        this.name = name;
    }
}

export class Move {
    type: "Move";
    name?: string;

    constructor(name?: string) {
        this.type = "Move";
        this.name = name;
    }
}

export class Response {
    elements: Element3D[];

    constructor(elements: Element3D[]) {
        this.elements = elements;
    }
}
